module.exports = __webpack_public_path__ + "f7155616b1f171c90aa483ace586b0ca.fbx";